import { RootState } from '@state/types';
import { CourseState } from './types';
import { CourseGradeResponse } from 'shovel-lib/types';

export const getCourseInfo = ({ course, calendar }: RootState): CourseState => {
  if (course.id !== course.courseDetailsDialog.courseId) {
    const courseInfo = calendar.courses.find(c => c.id === course.courseDetailsDialog.courseId);
    return {
      name: courseInfo?.name,
      colorHex: courseInfo?.colorHex,
      ordinalNumber: courseInfo?.ordinalNumber,
      taskCategories: [],
      readingSources: [],
      grade: {} as CourseGradeResponse,
      teachers: {},
      notes: null,
      courseDetailsDialog: course.courseDetailsDialog,
      gradesDialog: course.gradesDialog
    };
  }
  return course;
};

export const getCourseInfoForGrades = ({ course }: RootState): CourseState => {
  if (course.id !== course.gradesDialog.courseId) {
    return {
      taskCategories: [],
      readingSources: [],
      grade: {} as CourseGradeResponse,
      teachers: {},
      notes: null,
      courseDetailsDialog: course.courseDetailsDialog,
      gradesDialog: course.gradesDialog
    };
  }
  return course;
};

export const getCourseId = ({ course }: RootState) => {
  if (!course.id) {
    throw Error('Missing id in course state.');
  }
  return course.id;
};

export const getCourseCorrelationId = ({ course }: RootState) => course.correlationId;

export const getCategories = ({ course }: RootState) => course.taskCategories;

export const getReadingSources = ({ course }: RootState) => course.readingSources;

export const getCourseDetailsDialog = ({ course }: RootState) => course.courseDetailsDialog;

export const getGradesDialog = ({ course }: RootState) => course.gradesDialog;

export const getOpenedCourseDetailsCourseId = ({ course }: RootState) => course.courseDetailsDialog.courseId;

export const getOpenedGradesCourseId = ({ course }: RootState) => course.gradesDialog.courseId;
